import { BaseDocumentApi } from './api.base';
import { ApiConfig, apiNet } from '@cems-eco/core/src/services/api';

export class CloudDocumentApi extends BaseDocumentApi {
    
    async all(): Promise<any> {
        return await apiNet.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await apiNet.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await apiNet.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await apiNet.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await apiNet.delete<any>(`${this.BASE_URL}/${id}`);
    }

    async upload(data: any): Promise<any> {
        data = apiNet.toFormData(data);
        const config: ApiConfig = {
            isAuth: true,
            isFormData: true
        }
        return await apiNet.post<any>(`${this.BASE_URL}/upload`, data, config);
    }

}
